export default function TypingLoader() {
  return (
    <div className="flex items-center gap-1">
      <div className="size-1.5 bg-ss-neutral-400 rounded-full animate-bounce-more"></div>
      <div className="size-1.5 bg-ss-neutral-400 rounded-full animate-bounce-more [animation-delay:0.12s]"></div>
      <div className="size-1.5 bg-ss-neutral-400 rounded-full animate-bounce-more [animation-delay:0.24s]"></div>
    </div>
  )
}
